import React, { useRef } from 'react';

import { FormikHelpers } from 'formik';

import OnboardingSelect from 'components/Selects/OnboardingSelect';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Error } from './styles';

interface Props {
  id?: string;
  type?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  formik?: FormikHelpers<string>;
}

const RoomPreferenceSelector = ({ value, formik, error, disabled }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const { t } = useStoreTranslation();
  const ROOM_PREFERENCE_TYPES = [
    { id: '', name: t('roomPreferenceSelector.noPrefer') },
    { id: 'NonSmoking', name: t('roomPreferenceSelector.nonSmoking') },
  ];

  const handleChange = (newValue: any) => formik?.setFieldValue('roomPreferenceType', newValue);

  return (
    <div ref={ref}>
      <OnboardingSelect
        disabled={disabled}
        title={t('roomPreferenceSelector.title')}
        options={ROOM_PREFERENCE_TYPES}
        value={value}
        onChange={handleChange}
      />
      {error && <Error>{error}</Error>}
    </div>
  );
};

export default RoomPreferenceSelector;
